{
  "NOT_EMPTY": "This field cannot be empty",
  "COUNTRY_FORMAT": "You should select one country from the list",
  "SELECT_FROM_THE_LIST": "You should select at least one item from the list",
  "INVALID_EMAIL": "Email invalid format",
  "INVALID_BOOLEAN": "This field is not a boolean",
  "INVALID_ENUM": "This field cannot be empty",
  "INVALID_ZIP": "This field must be a valid ZIP code",
  "INVALID_PHONE_NUMBER": "This field must be a valid phone number",
  "INVALID_DATE_STRING": "This field must be a valid (YYYY-MM-DD) date string",
  "INVALID_NUMBER": "This field must be a number",
  "INVALID_UUID": "This field must be a valid UUID",
  "PASSWORD_NOT_STRONG": "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number and one special character",
  "MIN": "{property} with value: \"{value}\" needs to be at least {constraints.0}",
  "MAX": "{property} with value: \"{value}\" needs to be less than {constraints.0}",
  "MAX_PERCENTAGE": "The max percentage value is 100%",
  "NOT_DEFINED": "This field is not defined",
  "EMAIL_REGISTERED": "Email is already registered",
  "INVALID_CREDENTIALS": "Invalid credentials. Please try again.",
  "PASSWORD": {
    "minlength": "Password needs at least 8 characters",
    "minLowercase": "Password needs at least one lower letter",
    "minUppercase": "Password needs at least one upper letter",
    "minNumbers": "Password needs at least one number",
    "minSymbols": "Password needs at least one special character",
    "notMatch": "Passwords do not match. Please try again."
  },
  "INVALID_IBAN": "This field must be a valid IBAN number",
  "INVALID_SWIFTBIC": "This field must be a valid SWIFT BIC code",
  "INVALID_ROUTINGNUMBER": "This field must be equal or longer than 9 characters",
  "FULL_NAME_REQUIRED": "This field must be a valid full name",
  "INVALID_STATE": "This field must be in the format of two capital letters",
  "INVALID_MIN_CORPORATE_TAX_REFERENCE_NUMBER": "This field must have at least 9 digits",
  "INVALID_MAX_CORPORATE_TAX_REFERENCE_NUMBER": "This field must have at most 9 digits"
}
